import { render, staticRenderFns } from "./VerificationCodeInput.vue?vue&type=template&id=daaba036&scoped=true&"
import script from "./VerificationCodeInput.vue?vue&type=script&lang=js&"
export * from "./VerificationCodeInput.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCodeInput.vue?vue&type=style&index=0&id=daaba036&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaba036",
  null
  
)

export default component.exports